import {
  IonButton,
  IonContent,
  IonPopover,
  IonSpinner,
} from "@ionic/react";
import React, { useState } from "react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";

interface Props {
  id: string;
  name: string;
}

async function downloadReport(
  token: string,
  id: string,
) {
  return fetch(`${API_URL}/reports/cost_avoidance`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      building: id,
    }),
  }).then(async (res: any) => {
    if (res.ok) {
      return res.blob();
    } else {
      const data = await res.json();
      return {
        error: data.error,
      };
    }
  });
}

const CostAvoidanceReportButton: React.FC<Props> = ({ id, name }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res = await downloadReport(token, id,);
    if ("error" in res) {
      NotificationPopUp("error", res["error"], "Error Generating Report");
    } else {
      const url = window.URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}_Cost_Avoidance_Report.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode!.removeChild(link);
    }
    setLoading(false);
  };

  return (
    <div>
      <IonButton
        id="download-cost-avoidance-report"
        fill="solid"
        size="small"
        color="medium"
        // onClick={()=>handleDownload()}
      >
        Cost Avoidance Report
      </IonButton>
      <IonPopover
        trigger="download-cost-avoidance-report"
        size="auto"
        side="top"
        alignment="center">
          <IonContent color="medium" style={{ padding: "1rem" }}>
            <div style={{textAlign: "center", padding: "0.2rem"}}>
              <IonButton
                fill="solid"
                color="primary"
                size="small"
                onClick={() => handleDownload()}
                >
                  {loading ? <IonSpinner /> : "Download"}
              </IonButton>
              <IonButton
                fill="solid"
                color="primary"
                size="small"
                href={`cost_avoidance_report/${id}/edit`}
                disabled={loading}
                >
                  Edit Report
              </IonButton>
            </div>
            
          </IonContent>
        </IonPopover>

    </div>
  );
};

export default CostAvoidanceReportButton;
